<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>仓库列表</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <el-card shadow="hover">
            <!-- 搜索 -->
            <el-form :inline="true" size="small" v-model="listQuery">
                <el-form-item label="城市">
                    <el-select v-model="listQuery.cityId" clearable placeholder="请选择城市" filterable @change="cityChange2">
                        <el-option v-for="(item,index) in cityList" :key="index" :label="item.cityName" :value="item.id+''"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="服务站">
                    <el-select v-model="listQuery.stationId" clearable placeholder="请选择服务站" filterable>
                        <el-option v-for="(item,index) in queryStationList" :key="index" :label="item.stationName" :value="item.id+''"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="仓库名称">
                    <el-input v-model="listQuery.houseName" placeholder="请输入仓库" clearable></el-input>
                </el-form-item>
                <el-form-item label="状态">
                    <el-select v-model="listQuery.type" clearable placeholder="请选择类型">
                        <el-option label="普通类型" :value="1"></el-option>
                        <el-option label="维修" :value="2"></el-option>
                        <el-option label="报废" :value="3"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button icon="el-icon-search" type="primary" plan @click="querySearch">查询</el-button>
                    <el-button icon="el-icon-plus" v-per="'addwarehouse'" type="primary" plan @click="addWarehouse">新增仓库</el-button>
                </el-form-item>
            </el-form>

            <!-- 列表数据 -->
            <el-table :data="listData" border style="width: 100%" class="table">
                <el-table-column prop="id" label="ID" width="50px" fixed="left"></el-table-column>

                <el-table-column prop="houseName" label="仓库名称" width="160" fixed="left"></el-table-column>
                <el-table-column prop="houseAddress" label="仓库地址"></el-table-column>
                <el-table-column prop="cityName" label="城市">

                    <template slot-scope="scope">
                        {{cityFmt(scope.row.cityId)}}
                    </template>
                </el-table-column>
                <el-table-column prop="stationNames" label="服务站"></el-table-column>
                <el-table-column prop="status" label="状态">
                    <template slot-scope="scope">
                        <el-tag type="success" v-if="scope.row.status==1">启用</el-tag>
                        <el-tag type="danger" v-if="scope.row.status==2">停用</el-tag>
                        <el-tag type="info" v-if="scope.row.status==3">盘库中</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="type" label="仓库类型">
                    <template slot-scope="scope">
                        <span v-if="scope.row.type==1">普通仓库</span>
                        <span v-if="scope.row.type==2">维修</span>
                        <span v-if="scope.row.type==3">报废</span>
                    </template>
                </el-table-column>

                <el-table-column prop="createTime" label="创建时间" :formatter="dateFormatA" width="140px"></el-table-column>
                <el-table-column prop="updateTime" label="更新时间" :formatter="dateFormatA" width="140px"></el-table-column>

                <el-table-column prop label="操作" fixed="right" width="180px" align="center">
                    <template slot-scope="scope">
                        <el-button type="success" v-per="'updatewarehouse'" plain @click="editWarehouse(scope.row)" :disabled="scope.row.status==2" size="mini">编辑</el-button>
                        <el-button type="danger" v-per="'stopwarehouse'" plain @click="houseStatus(scope.row)" v-if="scope.row.status==1" class="red" size="mini">停用</el-button>
                        <el-button type="success" v-per="'usewarehouse'" plain @click="houseStatus(scope.row)" v-if="scope.row.status==2" size="mini">启用</el-button>
                    </template>
                </el-table-column>
            </el-table>

            <!-- 分页 -->
            <pagination :total="total" :page.sync="currentPage" :limit.sync="pageSize" @pagination="querySearch" />
        </el-card>

        <!-- 新增仓库 -->
        <el-dialog title="新增仓库" :visible.sync="addWarehouseVisible" width="600px" :close-on-click-modal="false" center>
            <el-form ref="addWarehouseForm" :rules="addRules" label-width="100px" :model="addWarehouseForm" size="medium">
                <el-row>
                    <el-form-item label="城市" prop="cityId">
                        <el-select v-model="addWarehouseForm.cityId" clearable placeholder="请选择城市" filterable @change="cityChange">
                            <el-option v-for="(item,index) in cityList" :key="index" :label="item.cityName" :value="item.id+''"></el-option>
                        </el-select>
                    </el-form-item>
                </el-row>
                <el-row>
                    <el-form-item label="服务站" prop="stationIds">
                        <el-select v-model="addWarehouseForm.stationIds" clearable placeholder="请选择服务站" multiple filterable>
                            <el-option v-for="(item,index) in stationList" :key="index" :label="item.stationName" :value="item.id+''"></el-option>
                        </el-select>
                    </el-form-item>
                </el-row>
                <el-row>
                    <el-form-item label="仓库名称" prop="houseName">
                        <el-input v-model="addWarehouseForm.houseName" clearable placeholder="请输入仓库名称"></el-input>
                    </el-form-item>
                </el-row>
                <el-row>
                    <el-form-item label="仓库地址" prop="houseAddress">
                        <el-input v-model="addWarehouseForm.houseAddress" clearable placeholder="请输入仓库地址"></el-input>
                    </el-form-item>
                </el-row>
                <el-row>
                    <el-form-item label="仓库类型" prop="type">
                        <el-select v-model="addWarehouseForm.type" clearable placeholder="请选择仓库类型">
                            <el-option label="普通仓库" :value="1"></el-option>
                            <el-option label="维修" :value="2"></el-option>
                            <el-option label="报废" :value="3"></el-option>
                        </el-select>
                    </el-form-item>
                </el-row>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click=" addWarehouseVisible= false">取 消</el-button>
                <el-button type="primary" @click="confAddWarehouse('addWarehouseForm')">确 定</el-button>
            </span>
        </el-dialog>

        <!-- 修改仓库 -->

        <el-dialog title="修改仓库" :visible.sync="editWarehouseVisible" width="600px" :close-on-click-modal="false" center>
            <el-form ref="editWarehouseForm" :rules="editRules" label-width="100px" :model="editWarehouseForm" size="medium">
                <el-row>
                    <el-form-item label="城市" prop="cityId">
                        <el-select v-model="editWarehouseForm.cityId" clearable placeholder="请选择城市" @change="cityChange" filterable>
                            <el-option v-for="(item,index) in cityList" :key="index" :label="item.cityName" :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                </el-row>

                <el-row>
                    <el-form-item label="服务站" prop="stationIds">
                        <el-select v-model="editWarehouseForm.stationIds" clearable placeholder="请选择服务站" multiple filterable>
                            <el-option v-for="(item,index) in stationList" :key="index" :label="item.stationName" :value="item.id+''"></el-option>
                        </el-select>
                    </el-form-item>
                </el-row>
                <el-row>
                    <el-form-item label="仓库名称" prop="houseName">
                        <el-input v-model="editWarehouseForm.houseName" clearable placeholder="请输入仓库名称"></el-input>
                    </el-form-item>
                </el-row>
                <el-row>
                    <el-form-item label="仓库地址" prop="houseAddress">
                        <el-input v-model="editWarehouseForm.houseAddress" clearable placeholder="请输入仓库地址"></el-input>
                    </el-form-item>
                </el-row>
                <el-row>
                    <el-form-item label="仓库类型" prop="type">
                        <el-select v-model="editWarehouseForm.type" disabled placeholder="请选择仓库类型">
                            <el-option label="普通仓库" :value="1"></el-option>
                            <el-option label="维修" :value="2"></el-option>
                            <el-option label="报废" :value="3"></el-option>
                        </el-select>
                    </el-form-item>
                </el-row>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click=" editWarehouseVisible= false">取 消</el-button>
                <el-button type="primary" @click="confEditWarehouse('editWarehouseForm')">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import moment from "moment";
import Pagination from "../common/Pagination";
import wmsApi from "@/script/api/wmsApi";
import globalData from "@/components/common/globaldata/global.data.vue";
import "./css/index.css";
export default {
    components: { Pagination },
    data() {
        return {
            listData: [],
            total: 0,
            pageSize: 10,
            currentPage: 1, //当前页
            listQuery: {
                houseName: "",
                type: "",
                cityId: "",
                stationId: "",
            },
            cityList: [],
            stationList: [],
            queryStationList: [],
            addWarehouseVisible: false,
            addWarehouseForm: {
                cityId: "",
                stationIds: [],
                houseName: "",
                houseAddress: "",
                type: 1,
            },
            addRules: {
                cityId: [
                    {
                        required: true,
                        message: "请选择城市",
                        trigger: "change",
                    },
                ],
                // stationIds: [
                //   { required: true, message: "请选择服务站", trigger: "change" }
                // ],
                houseName: [
                    {
                        required: true,
                        message: "请输入仓库名称",
                        trigger: "change",
                    },
                ],
                houseAddress: [
                    {
                        required: true,
                        message: "请输入仓库地址",
                        trigger: "change",
                    },
                ],
                type: [
                    {
                        required: true,
                        message: "请选择仓库类型",
                        trigger: "change",
                    },
                ],
            },
            houseInfo: {},
            editWarehouseVisible: false,
            editWarehouseForm: {
                cityId: "",
                stationIds: [],
                houseName: "",
                houseAddress: "",
                type: 1,
            },
            editRules: {
                // stationIds: [
                //   { required: true, message: "请选择服务站", trigger: "change" }
                // ],
                houseName: [
                    {
                        required: true,
                        message: "请输入仓库名称",
                        trigger: "change",
                    },
                ],
                houseAddress: [
                    {
                        required: true,
                        message: "请输入仓库地址",
                        trigger: "change",
                    },
                ],
                type: [
                    {
                        required: true,
                        message: "请选择仓库类型",
                        trigger: "change",
                    },
                ],
            },
        };
    },
    created() {
        this.querySearch();
        this.getAllStationList();
    },
    methods: {
        cityChange2(value) {
            this.listQuery.stationId = [];
            let currentStation = this.cityList.filter((item) => {
                return item.id == value;
            });
            if (currentStation == null) {
                this.queryStationList = [];
            } else {
                this.queryStationList = currentStation[0].stationList;
            }
        },
        cityChange(value) {
            this.addWarehouseForm.stationIds = [];
            let currentStation = this.cityList.filter((item) => {
                return item.id == value;
            });
            if (currentStation == null) {
                this.stationList = [];
            } else {
                this.stationList = currentStation[0].stationList;
            }
        },
        //查询
        querySearch() {
            let temp = {
                pageNum: this.currentPage,
                pageSize: this.pageSize,
                houseName: this.listQuery.houseName,
                type: this.listQuery.type,
                userId: globalData.userInfo.id,
                stationId: this.listQuery.stationId,
                cityId: this.listQuery.cityId,
            };
            wmsApi
                .$axiosGetWmshousePageList(temp)
                .then((res) => {
                    this.listData = res.data.data.list;
                    this.total = res.data.data.total;
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        houseStatus(row) {
            this.$confirm(`确定${row.status == 1 ? "停用" : "启用"}该仓库吗？`)
                .then((_) => {
                    wmsApi
                        .$axiosUpdateStatus({
                            updateUserId: globalData.userInfo.id,
                            updateUserName: globalData.userInfo.userName,
                            id: row.id,
                            status: row.status == 1 ? 2 : 1,
                        })
                        .then((res) => {
                            this.$message.success(
                                `${row.status == 1 ? "停用" : "启用"}成功！`
                            );
                            this.querySearch();
                        })
                        .catch((err) => {
                            console.log(err);
                        });
                })
                .catch((_) => {});
            console.log(row);
        },
        getAllStationList() {
            wmsApi
                .$axiosCityStationGetAll({})
                .then((res) => {
                    this.cityList = res.data.data;
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        addWarehouse() {
            this.stationList = [];
            this.addWarehouseVisible = true;
            this.addWarehouseForm = {
                stationIds: [],
                houseName: "",
                houseAddress: "",
                type: 1,
            };
        },
        confAddWarehouse(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    let params = {
                        createUserId: globalData.userInfo.id,
                        createUserName: globalData.userInfo.userName,
                        stationIds: this.addWarehouseForm.stationIds,
                        houseAddress: this.addWarehouseForm.houseAddress,
                        houseName: this.addWarehouseForm.houseName,
                        type: this.addWarehouseForm.type,
                        cityId: this.addWarehouseForm.cityId,
                    };

                    wmsApi.$axiosWmshouseAdd(params).then((res) => {
                        if (res.data.errno == 0) {
                            this.$message.success("添加成功");
                            this.addWarehouseVisible = false;
                            this.querySearch();
                        } else {
                            this.$message.error(res.data.data);
                        }
                    });
                } else {
                    console.log("error submit!!");
                    return false;
                }
            });
        },
        editWarehouse(row) {
            let currentStation = this.cityList.filter((item) => {
                return item.id == row.cityId;
            });
            this.stationList = currentStation[0].stationList;

            this.houseInfo = row;
            this.editWarehouseVisible = true;
            this.editWarehouseForm = {
                cityId: row.cityId,
                stationIds:
                    row.stationIds == "" ? [] : row.stationIds.split(","),
                houseName: row.houseName,
                houseAddress: row.houseAddress,
                type: row.type,
            };
        },
        confEditWarehouse(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    let params = {
                        createUserId: globalData.userInfo.id,
                        createUserName: globalData.userInfo.userName,
                        stationIds: this.editWarehouseForm.stationIds,
                        houseAddress: this.editWarehouseForm.houseAddress,
                        houseName: this.editWarehouseForm.houseName,
                        type: this.editWarehouseForm.type,
                        id: this.houseInfo.id,
                        cityId: this.houseInfo.cityId,
                    };

                    wmsApi.$axiosWmshouseUpdate(params).then((res) => {
                        if (res.data.errno == 0) {
                            this.$message.success("修改成功");
                            this.editWarehouseVisible = false;
                            this.querySearch();
                        } else {
                            this.$message.error(res.data.data);
                        }
                    });
                } else {
                    console.log("error submit!!");
                    return false;
                }
            });
        },
        cityFmt(cityId) {
            // console.log(cityId);
            let name = "";
            if (cityId != null) {
                let c = this.cityList.forEach((e) => {
                    if (e.id == cityId) {
                        name = e.cityName;
                    }
                });
            }
            return name;
        },
    },
};
</script>
<style scoped>
.crumbs {
    margin: 0 0 10px 0;
}
.btn-margin .el-button--small {
    margin: 10px 12px 0 0;
}
.el-image img {
    height: 60px;
    width: 60px;
    margin: 0 12px 12px 0;
    object-fit: cover;
}
</style>
